/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.GraphicObject = function( xml, type, jsonObject) {
    var config = expocadfx.config;
    var getTextObj = expocadfx.util.textFromXML;
    var getJSONTextObj = expocadfx.util.textFromJSON;
    
    var i = 0;
    var arText = null;
	var textObject = null;
    var points = null;
    var len = 0;
	var line = null;

    var obj = {
        index: -1,
        path: [],
        numPoints: 0,
        numText: 0,
        expColor: "",
        strokeColor: "",
        fillColor: "",          //  for 3d
        fillStyle: "",          //  for 2d to support gradients
        displayColor: "",
        saveColor: "",
        lineWidth: 1,
        alpha: 0,
        type: type,
        closePath: true,
        fill: false,
        stroke: false,
        text: [],
		dimensionText: [],
        minX: 70000,
        minY: 70000,
        maxX: 0,
        maxY: 0,
        center: null,
        vertices: null,
        mesh: null,
        textMesh: null,
        selected: false,
        hasSize: true
    };
     
    
    if(xml !== null) {
		line = xml.getElementsByTagName("L")[0];
		
		if( line === undefined) {
			obj.expColor = xml.getAttribute("c").replace("0x","#");
//			obj.lineWidth = parseInt( xml.getAttribute("w"), 10);
		}
		else {
			obj.expColor = line.getAttribute("c").replace("0x","#");
//			obj.lineWidth = parseInt( line.getAttribute("w"), 10);
		}
			
        arText = xml.getElementsByTagName("T");
        obj.numText = arText.length;
        
        points = xml.getElementsByTagName("P");
        len = points.length;
        obj.numPoints = len;
        
        for (i = 0; i < len; i++) {
            obj.path.push( { x:parseInt( points[i].getAttribute("x"), 10),
                             y:parseInt( points[i].getAttribute("y"), 10) });
        }
        
        if( arText && arText.length > 0) {
            obj.numText = arText.length;
            for( i = 0; i < obj.numText; i++) {
				textObject = getTextObj( arText[i], config.clrBoothText, config.FLOOR_PLAN_FONT);
				if( textObject.isDimension) {
					textObject.fill = config.clrBoothDimensions;
					obj.dimensionText.push( textObject);
				}
				else {
					obj.text.push( textObject);
				}
            }
        }
    }

    if (jsonObject != null) {

        //obj.expColor = "#0000ff";
        obj.expColor = jsonObject.colorOverride;
        // obj.lineWidth = "2";
        var WKT = jsonObject.geometry[0].corners;
        var coordsPtsArr = WKT;

        for (var k = 0; k < coordsPtsArr.length; k++) {

            obj.path.push({
                x: coordsPtsArr[k].x,
                y: coordsPtsArr[k].y
                //y: Math.abs(8437 - coordsPtsArr[k].y) // should be event Y extent minus Y coord
                //y: Math.abs(5900 - coordsPtsArr[k].y)
            });
        }
        obj.numPoints = obj.path.length;

        arText = jsonObject.textItems;
        //arText = [1];
        
        // if(arText !== null){
        //     obj.numText = arText.length;
        // }
        if( arText && arText.length > 0) {
            obj.numText = arText.length;
            for( i = 0; i < obj.numText; i++) {
                // textObject = getJSONTextObj( arText[i], config.clrBoothText, config.FLOOR_PLAN_FONT);
                textObject = getJSONTextObj( arText[i], config.clrBoothText, config.FLOOR_PLAN_FONT);
				if( textObject.isDim) {
					textObject.fill = config.clrBoothDimensions;
					obj.dimensionText.push( textObject);
				}
				else {
					obj.text.push( textObject);
				}
            }
        }
        
    }

    switch( type) {
        case "T":
			obj.lineWidth = config.boothBorderLineWidth;
            obj.fill = true;
            obj.stroke = true;
            obj.alpha = config.BOOTH_ALPHA;
            break;
        case "P":
        obj.fill = true;
        if(obj.expColor == ""){ obj.expColor = config.PAVILION_COLOR};      
            obj.alpha = config.PAVILION_ALPHA;
            obj.fillColor = obj.expColor;
            obj.displayColor = obj.expColor;
            obj.strokeColor = obj.expColor;
            break;
        case "F":
        if(obj.expColor == ""){ obj.expColor = config.PAVILION_COLOR};      
        obj.closePath = false;
            obj.stroke = true;
            obj.alpha = 1.0;  // config.GRAPHIC_ALPHA ??;
            obj.strokeColor = obj.expColor;
            break;
    }
    return obj;
};